module.exports = __webpack_public_path__ + "img/bid-open-hall-head.446aed88.png";